import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {fetchSocialTemplates} from "../../../../../actions";
import {Col, Row} from "reactstrap";
import TileAdminSocialCurrentTemplates
    from "../../../../../components/customBreachBits/admin/AdminSocialComponents/TileAdminSocialCurrentTemplates";
import TileComingSoon from "../../../../../components/customBreachBits/metrics/TileComingSoon";
import CurrentSocialTestTemplatesTable
    from "../../../../../components/customBreachBits/admin/AdminSocialComponents/CurrentSocialTestTemplatesTable";

const AdminSocialPage = ({props})=>{

    const {templates, loadingTemplates, loadingTemplatesError, creatingTemplate, creatingTemplateError} = useSelector(({admin})=> admin);
    const { customers, loadingCustomers } = useSelector(({customer})=> customer);

    const dispatch = useDispatch();

    useEffect(()=>{
        if(!templates && !loadingTemplates && !loadingTemplatesError){
            dispatch(fetchSocialTemplates());
        }
    }, [templates, loadingTemplates, loadingTemplatesError]);


    return(
        <div className="animated fadeIn animation-duration-7">
            <div  className="app-wrapper h-100">

                <Row>
                    <Col>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <TileComingSoon subtitle={"Customers with Social Testing"}/>
                    </Col>
                    <Col>
                        <TileAdminSocialCurrentTemplates/>
                    </Col>
                    <Col>
                        <TileComingSoon/>
                    </Col>
                    <Col>
                        <TileComingSoon/>
                    </Col>
                </Row>

                <CurrentSocialTestTemplatesTable/>



            </div>
        </div>
    )
}

export default AdminSocialPage;